<template>
    <div class="pa-4">
        <h1 class="mb-5 text--xl font-weight-medium">{{ $t('navigation.subcontractors') }}</h1>
        <FiltersBar :withFilters="false"
                    ref="filtersBar"></FiltersBar>

        <SubContractorsTable @change-page="changePage($event)"
                        @change-amount="changeAmount($event)"
                        @sort="sortingColumn = $event"
                        @fetch="fetchSubContractors"
                        :loader="loader"
                        :changed-page="pagination.page"></SubContractorsTable>

        <ManageSubContractors @fetch="fetchSubContractors"></ManageSubContractors>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import SubContractorsTable from '@/components/subContractors/SubContractorsTable';
import FiltersBar from '@/components/widgets/tables/FiltersBar';
import ManageSubContractors from '@/components/subContractors/ManageSubContractors';

export default {
    name: 'SubContractors',
    components: {
        SubContractorsTable,
        FiltersBar,
        ManageSubContractors
    },
    data: () => ({
        pagination: {
            page: 1,
            amount: 20,
            amountAll: null
        },
        loader: false,
        sortingColumn: null
    }),
    computed: {
        ...mapFields('search', [
            'search'
        ])
    },
    watch: {
        sortingColumn: {
            handler () {
                this.fetchSubContractors();
            },
            deep: true
        },
        search: {
            handler (val, oldVal) {
                if ((val && val.length >= 2) || (oldVal && val === '')) {
                    this.pagination.page = 1;
                    this.fetchSubContractors();
                }
            }
        }
    },
    methods: {
        fetchSubContractors () {
            this.loader = true;

            const params = {
                'page': this.pagination.page,
                'page_size': this.pagination.amount
            };

            // if (this.sortingColumn) {
            //     params.sort = this.sortingColumn.value === 'asc' ? this.sortingColumn.name : `-${this.sortingColumn.name}`;
            // }

            if (this.search) {
                params.search = this.search;
            }

            this.$store.dispatch('subContractors/getSubContractors', params)
                .finally(() => {
                    this.loader = false;
                });
        },
        changePage (event) {
            this.pagination.page = event;
            this.fetchSubContractors();
        },
        changeAmount (event) {
            this.pagination.page = 1;
            this.pagination.amount = event;
            this.fetchSubContractors();
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$can(vm.$abilityActions.READ, vm.$abilitySubjects.SUBCONTRACTORS)) {
                vm.fetchSubContractors();
            } else {
                vm.$router.push({ name: 'home' });
            }
        });
    },
    beforeRouteLeave (to, from, next) {
        this.search = null;
        next();
    }
};
</script>

<style scoped>

</style>
